@if(enablePage.showAmendSaveThankYouPage && data){
<section class="col-xs-12 col-md-12 mt-5" id="thanksave">
  <div class="thankorder_box">
   <!--  @if(!isAsAgent){ -->
    <span  class="thankorder_head" [innerHtml]="data.headLine"></span><span  class="thankorder_head"> {{seasonValue | seasonspilt}} season</span>
    <div class="thankorder_wrapper">
      <div class="thankordersave mt-4" [innerHtml]="data.t2content"></div>
      <span class="thankordersave" [innerHtml]="data.t2linkurl"></span>
   </div>
 <!--  } -->
  <!--  @else{
    <span  class="thankorder_head asmtext">The amended pre-order has been sent to the customer for their confirmation</span>

   } -->
 
  <a class="my-order-anchor showPopupclick" [routerLink]="['/orders/my-orders']" [queryParams]= "{'season': seasonValue}" (click)="handleOnOrdersClick()">
    <div class="viewbutton">{{"startorderUk.viewOrders" | cxTranslate}}</div>
  </a>
  @if(data?.name){
  <div class="omsjob_code">{{data?.name}}</div>
  }
</div>
</section>
}